import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { EventOverview } from 'src/app/core-module/models/Events/event-overview';

@Component({
  selector: 'app-event-overview-panel',
  imports: [CommonModule],
  templateUrl: './event-overview-panel.component.html',
  styleUrl: './event-overview-panel.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:true
})
export class EventOverviewPanelComponent {
  @Input() event: EventOverview;
  @Input() readonly: boolean = false;

  constructor(private router:Router){
    
  }

  openEvent(){
    if (!this.readonly){
      this.router.navigateByUrl('/events/' + this.event.EventID);
    }
    
  }
}
